import React, {lazy, Suspense, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import Loader from './components/loader';
import {PLAYOFF_EMPTY_STAGES} from './constants/play-off-empty-stages';
import {Theme} from './contexts/theme';
import {fetchData} from './utils/helpers';

const EuroMobileContainer = lazy(() => import(
  /* webpackChunkName: "euro-2020-mobile" */'./mobile-container'
));
const EuroDesktopContainer = lazy(() => import(
  /* webpackChunkName: "euro-2020-desktop" */'./desktop-container'
));

const LANGUAGE_LOCALES = {
  www: 'ru-KZ',
  kaz: 'kk-KZ'
};

export default ({
  isMobile,
  mockData = {groups: [], stages: []},
  apiUrl,
  theme,
  chunkSize
}) => {
  const {i18n: {language}} = useTranslation();
  const [data, setData] = useState({
    groups: mockData.groups,
    playOffStages: mockData.stages,
    isLoading: !mockData.groups.length
  });
  const requestLocale = LANGUAGE_LOCALES[language];

  useEffect(async () => {
    if (mockData.groups.length || !apiUrl) {
      return;
    }

    try {
      const groups = await fetchData({url: `${apiUrl.groups}?locale=${requestLocale}`});

      setData({...data, groups});

      const playOffStages = await fetchData({url: `${apiUrl.stages}?locale=${requestLocale}`});

      const resultStages = playOffStages.length ? playOffStages : PLAYOFF_EMPTY_STAGES;

      setData({groups, playOffStages: resultStages, isLoading: false});
    } catch (e) {
      setData({...data, isLoading: false});
      console.error(`${theme} error: ${e}`);
    }
  }, [apiUrl, requestLocale]);

  return (
    <Suspense fallback={<Loader color='#fff' />}>
      <Theme.Provider value={theme}>
        {isMobile
          ? <EuroMobileContainer {...data} />
          : <EuroDesktopContainer {...data} chunkSize={chunkSize} />
        }
      </Theme.Provider>
    </Suspense>
  );
};
